import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiCall } from "../main/Apicall";
import "../css/others/Table.css";
import Pagination from "../Reusablecomponents/Pagination";
import { FunctionChecklistDetails } from "../Interfaces/Interface"
const FunctionViewCheckListDetails: React.FC = () => {
  const { functionTemplateId } = useParams<{ functionTemplateId: string }>();
  const [details, setDetails] = useState<FunctionChecklistDetails | null>(null);
  const [, setLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const fetchChecklistDetails = useCallback(async () => {
    if (!functionTemplateId) return;
    setLoading(true);
    try {
      const checklist = await apiCall("get", `/api/function/templates/${functionTemplateId}/questions`, undefined, { page: currentPage - 1, size: itemsPerPage });
      setDetails(checklist || { content: [] });
    } catch (error) {
      console.error("Error fetching checklist details:", error);
    } finally {
      setLoading(false);
    }
  }, [functionTemplateId, currentPage, itemsPerPage]);
  useEffect(() => { fetchChecklistDetails(); }, [fetchChecklistDetails]);
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Function Checklist Details</h2>
      </div>
      <div className="table-container">
        <div className="table-inner-container">
          <table className="main-table">
            <thead>
              <tr>
                <th>S.No.</th><th>Function Area Name</th><th>Question</th><th>Evidence Required</th><th>ISO Clause Reference</th><th>Annex A Control Reference</th>
              </tr>
            </thead>
            <tbody>
              {details?.content && details.content.length > 0 ? (
                details.content.map((item, index) => (
                  <tr key={item.functionQuestionId}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{item.functionAreaName || "Empty"}</td>
                    <td>{item.questionText || "Empty"}</td>
                    <td>{item.evidenceRequired || "Empty"}</td>
                    <td>{item.isoClauseReference || "Empty"}</td>
                    <td>{item.annexAControlReference || "Empty"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="no-data">No questions available for this checklist</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={details?.totalPages || 0}
        totalElements={details?.totalElements || 0}
        itemsPerPage={itemsPerPage}
        onPageChange={setCurrentPage}
        onItemsPerPageChange={setItemsPerPage}
      />
    </div>
  );
};
export default FunctionViewCheckListDetails;